import React from 'react';
import { Modal } from 'components';
import { StyledPreviewImage } from './StyledComponents';

export type PreviewPhoto = {
  name: string;
  url: string;
};

interface PhotoPreviewModalProps {
  visible: boolean;
  closeModal: () => void;
  previewImage: PreviewPhoto | null;
}

const PhotoPreviewModal: React.FC<PhotoPreviewModalProps> = ({
  visible,
  closeModal,
  previewImage,
}) => (
  <Modal
    open={visible}
    title={previewImage?.name}
    footer={null}
    onCancel={closeModal}
  >
    <StyledPreviewImage alt="listing-image" src={previewImage?.url} />
  </Modal>
);

export default PhotoPreviewModal;
